var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptystateRoutepending = function SvgEmptystateRoutepending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 6c0 3-4 6-4 6S6 9 6 6a4 4 0 0 1 8 0zm-2.5-.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 11.5 5.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.602 12.798.004-.003.012-.009.04-.031.141-.111a16.619 16.619 0 0 0 2.202-2.148V18l-6-2v-5.503a16.76 16.76 0 0 0 2.343 2.259l.04.031.012.009.004.003.6.451.602-.452zM14 18V9.123c.45-.736.817-1.565.948-2.439l3.736-1.245A1 1 0 0 1 20 6.387v8.892a1 1 0 0 1-.684.949L14 18zM5 6c0-.231.016-.459.046-.682L.684 6.772A1 1 0 0 0 0 7.721v8.892a1 1 0 0 0 1.316.949L6 16V9.123C5.434 8.197 5 7.125 5 6z"
  })));
};
export default SvgEmptystateRoutepending;